/* JHT Love — collection grid: card image carousel, infinite scroll, quick add. Vanilla, no deps. */
(function () {
  const grid = document.getElementById("plp-grid");
  if (!grid) return;

  /* ---- per-card image carousel + quick add (event delegation, survives appended cells) ---- */
  document.addEventListener("click", function (e) {
    const nav = e.target.closest(".cell-nav");
    if (nav && grid.contains(nav)) {
      e.preventDefault();
      e.stopPropagation();
      const media = nav.closest(".cell-media");
      const img = media && media.querySelector("img");
      if (!media || !img) return;
      let images;
      try {
        images = JSON.parse(media.dataset.images || "[]");
      } catch (_) {
        images = [];
      }
      if (images.length < 2) return;
      let i = parseInt(media.dataset.index || "0", 10);
      i = (i + (nav.classList.contains("next") ? 1 : -1) + images.length) % images.length;
      media.dataset.index = String(i);
      img.removeAttribute("srcset");
      img.src = images[i];
      return;
    }

    const atc = e.target.closest(".cell-atc[data-variant-id]");
    if (atc && grid.contains(atc)) {
      e.preventDefault();
      const id = atc.getAttribute("data-variant-id");
      if (window.JHT && window.JHT.cart && window.JHT.cart.add) {
        atc.classList.add("is-loading");
        Promise.resolve(window.JHT.cart.add(id, 1)).finally(function () {
          atc.classList.remove("is-loading");
        });
      }
    }
  });

  /* ---- mobile: tap the left/right third of a photo to step through its images ---- */
  if (window.matchMedia && window.matchMedia("(hover: none)").matches) {
    grid.addEventListener("click", function (e) {
      if (e.target.closest(".cell-nav") || e.target.closest(".cell-atc")) return;
      const media = e.target.closest(".cell-media");
      if (!media) return;
      let images;
      try {
        images = JSON.parse(media.dataset.images || "[]");
      } catch (_) {
        images = [];
      }
      if (images.length < 2) return;
      const rect = media.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const edge = rect.width * 0.32;
      let dir = 0;
      if (x < edge) dir = -1;
      else if (x > rect.width - edge) dir = 1;
      if (!dir) return; // centre tap → open the product
      e.preventDefault();
      const i = (parseInt(media.dataset.index || "0", 10) + dir + images.length) % images.length;
      media.dataset.index = String(i);
      const img = media.querySelector("img");
      if (img) {
        img.removeAttribute("srcset");
        img.src = images[i];
      }
      const nav = media.querySelector(dir > 0 ? ".cell-nav.next" : ".cell-nav.prev");
      if (nav) {
        nav.classList.add("flash");
        setTimeout(function () {
          nav.classList.remove("flash");
        }, 450);
      }
    });
  }

  /* ---- infinite scroll ---- */
  const sentinel = document.querySelector(".plp-sentinel");
  const moreBtn = document.querySelector("[data-load-more]");
  let loading = false;
  let observer;

  async function loadNext() {
    if (loading || !sentinel) return;
    const url = sentinel.dataset.nextUrl;
    if (!url) return;
    loading = true;
    if (moreBtn) moreBtn.classList.add("is-loading");
    try {
      const res = await fetch(url);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, "text/html");
      const cells = doc.querySelectorAll("#plp-grid .cell");
      cells.forEach(function (c) {
        grid.appendChild(document.importNode(c, true));
      });
      const nextSentinel = doc.querySelector(".plp-sentinel");
      const next = nextSentinel && nextSentinel.dataset.nextUrl;
      if (next) {
        sentinel.dataset.nextUrl = next;
      } else {
        delete sentinel.dataset.nextUrl;
        if (moreBtn) moreBtn.remove();
        if (observer) observer.disconnect();
      }
    } catch (_) {
      /* leave button for manual retry */
    }
    loading = false;
    if (moreBtn) moreBtn.classList.remove("is-loading");
    // keep filling while the sentinel is still near the viewport
    if (sentinel && sentinel.dataset.nextUrl && nearViewport(sentinel, 200)) loadNext();
  }

  function nearViewport(el, margin) {
    const r = el.getBoundingClientRect();
    return r.top < window.innerHeight + margin;
  }

  if (sentinel && sentinel.dataset.nextUrl && "IntersectionObserver" in window) {
    observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) loadNext();
      },
      { rootMargin: "1200px 0px" }
    );
    observer.observe(sentinel);
  }
  if (moreBtn) moreBtn.addEventListener("click", loadNext);

  /* fallback: load on scroll too, in case the observer doesn't fire */
  window.addEventListener(
    "scroll",
    function () {
      if (sentinel && sentinel.dataset.nextUrl && nearViewport(sentinel, 1200)) loadNext();
    },
    { passive: true }
  );

  /* initial fill: if the first page doesn't fill the screen, load the next */
  if (sentinel && sentinel.dataset.nextUrl && nearViewport(sentinel, 200)) loadNext();

  /* ---- image cycling: idle = one RANDOM card per row flips; hover = that card accelerates ---- */
  let hoverMedia = null;
  let hoverTimer = null;

  function advance(media) {
    let images;
    try {
      images = JSON.parse(media.dataset.images || "[]");
    } catch (_) {
      images = [];
    }
    if (images.length < 2) return;
    const img = media.querySelector("img");
    if (!img) return;
    const i = (parseInt(media.dataset.index || "0", 10) + 1) % images.length;
    media.dataset.index = String(i);
    const next = new Image();
    next.onload = function () {
      img.removeAttribute("srcset");
      img.src = images[i];
    };
    next.src = images[i];
  }

  function cyclable(media) {
    if (!media) return false;
    let n = 0;
    try {
      n = JSON.parse(media.dataset.images || "[]").length;
    } catch (_) {
      n = 0;
    }
    if (n < 2) return false;
    const r = media.getBoundingClientRect();
    return r.bottom > -150 && r.top < window.innerHeight + 150;
  }

  /* idle: flip exactly ONE random card at a time — never two together — at a lively pace */
  function cyclePool() {
    const pool = [];
    grid.querySelectorAll(".cell-media").forEach(function (m) {
      if (m !== hoverMedia && cyclable(m)) pool.push(m);
    });
    return pool;
  }
  function idleLoop() {
    const delay = 180 + Math.random() * 420; // 0.18s–0.6s between single flips
    setTimeout(function () {
      if (!document.hidden && !hoverMedia) {
        const pool = cyclePool();
        if (pool.length) advance(pool[Math.floor(Math.random() * pool.length)]);
      }
      idleLoop();
    }, delay);
  }

  /* hover: the hovered card cycles fast through all of its images */
  function startHover(media) {
    if (hoverMedia === media) return;
    stopHover();
    if (!cyclable(media)) return;
    hoverMedia = media;
    advance(media);
    hoverTimer = setInterval(function () {
      advance(media);
    }, 360);
  }
  function stopHover() {
    if (hoverTimer) clearInterval(hoverTimer);
    hoverTimer = null;
    hoverMedia = null;
  }
  grid.addEventListener("mouseover", function (e) {
    const m = e.target.closest(".cell-media");
    if (m && grid.contains(m)) startHover(m);
  });
  grid.addEventListener("mouseout", function (e) {
    const m = e.target.closest(".cell-media");
    if (m && m === hoverMedia && !m.contains(e.relatedTarget)) stopHover();
  });

  /* preload every image of cards near the viewport so cycling never flashes the background */
  const preloaded = new WeakSet();
  function preloadCard(media) {
    if (preloaded.has(media)) return;
    preloaded.add(media);
    let imgs = [];
    try {
      imgs = JSON.parse(media.dataset.images || "[]");
    } catch (_) {
      imgs = [];
    }
    imgs.forEach(function (src) {
      const im = new Image();
      im.src = src;
    });
  }
  /* wait for window load before bulk-preloading: it must never compete with the
     visible grid images (LCP) for bandwidth during the initial render */
  function startPreloading() {
    if ("IntersectionObserver" in window) {
      const preObs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              preloadCard(e.target);
              preObs.unobserve(e.target);
            }
          });
        },
        { rootMargin: "800px 0px" }
      );
      const observePre = function () {
        grid.querySelectorAll(".cell-media").forEach(function (m) {
          if (!preloaded.has(m)) preObs.observe(m);
        });
      };
      observePre();
      if ("MutationObserver" in window) {
        new MutationObserver(observePre).observe(grid, { childList: true });
      }
    } else {
      grid.querySelectorAll(".cell-media").forEach(preloadCard);
    }
  }
  if (document.readyState === "complete") {
    startPreloading();
  } else {
    window.addEventListener("load", startPreloading, { once: true });
  }

  if (!window.matchMedia || !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    idleLoop();
  }
})();
